// Flickity (used by the carousel-mode featured-collection sections and
// slideshow) marks off-screen/inactive slides aria-hidden="true" via its
// built-in accessibility option, but it does not also remove the focusable
// elements inside those slides (Add to Cart links, quickview buttons,
// wishlist buttons, etc.) from the tab order. Keyboard/screen-reader users
// can therefore Tab into buttons that are hidden from assistive tech -
// PageSpeed Insights flags this sitewide as "[aria-hidden=true] elements
// contain focusable descendants".
//
// This is intentionally generic rather than hooking Flickity's internal
// events: it just watches the DOM for aria-hidden changes (from Flickity or
// anything else) and keeps tabindex in sync on any focusable descendants,
// restoring each element's original tabindex once its container is no
// longer aria-hidden. It never touches click handlers, visibility, or
// layout, so it can't affect how any existing add-to-cart/quickview/
// wishlist interaction behaves via mouse or touch - only keyboard Tab
// order.
(function () {
  var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';
  var ORIGINAL_TABINDEX_ATTR = 'data-focus-fix-original-tabindex';

  function hideDescendants(container) {
    var focusable = container.querySelectorAll(FOCUSABLE_SELECTOR);
    for (var i = 0; i < focusable.length; i++) {
      var el = focusable[i];
      if (!el.hasAttribute(ORIGINAL_TABINDEX_ATTR)) {
        el.setAttribute(ORIGINAL_TABINDEX_ATTR, el.getAttribute('tabindex') || '');
      }
      el.setAttribute('tabindex', '-1');
    }
  }

  function restoreDescendants(container) {
    var previouslyHidden = container.querySelectorAll('[' + ORIGINAL_TABINDEX_ATTR + ']');
    for (var i = 0; i < previouslyHidden.length; i++) {
      var el = previouslyHidden[i];
      var original = el.getAttribute(ORIGINAL_TABINDEX_ATTR);
      if (original) {
        el.setAttribute('tabindex', original);
      } else {
        el.removeAttribute('tabindex');
      }
      el.removeAttribute(ORIGINAL_TABINDEX_ATTR);
    }
  }

  function sync(el) {
    if (el.getAttribute('aria-hidden') === 'true') {
      hideDescendants(el);
    } else {
      restoreDescendants(el);
    }
  }

  function init() {
    // Initial pass, in case anything is already aria-hidden by the time
    // this script runs (it's loaded deferred, after Flickity may have
    // already initialized on a fast connection).
    var alreadyHidden = document.querySelectorAll('[aria-hidden="true"]');
    for (var i = 0; i < alreadyHidden.length; i++) {
      sync(alreadyHidden[i]);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          sync(m.target);
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
